import { helpers, React, ts, ui, useSelector } from '_core';

import { formatData, prepareLinearData } from './helpers';
import { Params } from './types';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  portfolios: string;
  fullScreen: boolean;
  params: Params;
  title: string;
  setExternalEmbed: (_json: ts.types.analysis.EmbedChartData) => void;
  context?: ts.types.basket.BasketAnalysisContext;
};

const Chart = ({
  id,
  readOnly,
  fullScreen,
  loadWidgetData,
  portfolios,
  params,
  title,
  setExternalEmbed,
}: ChartProps) => {
  const baskets = useSelector((state) => state.resources.baskets);

  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [alert, setAlert] = React.useState<{ type: 'error' | 'warning'; message: string } | null>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: portfolios,
        },
      });
      if (response) {
        const formattedData = formatData(response.data, params.histories ?? []);
        setData(prepareLinearData(formattedData, true, baskets));
      }
    } catch (err) {
      setAlert({
        type: 'error',
        message: helpers.parseApiError(err as ts.types.common.ApiError),
      });
    }
  };
  React.useEffect(() => {
    if (portfolios) loadData();
    return () => setData(null);
  }, [portfolios]);

  return (
    <ui.LineChart
      id={id}
      data={data}
      alert={alert}
      readOnly={readOnly}
      numberFormat="#.##%"
      exportTitle={title}
      fullScreen={fullScreen}
      setExternalEmbed={setExternalEmbed}
      showEndValueLabel
      showPeriodSelector
    />
  );
};

export default Chart;
